import { theme } from '~/theme';

export type ClassKey = 'root' | 'header' | 'content' | 'actions';

export const useSxStyles = () => {
  return {
    actions: {
      height: 40,
      '& > *': {
        fontSize: '0.6875rem',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflow: 'hidden',
      padding: 0,
    },
    errorHandler: { margin: 'auto', textAlign: 'center' },
    header: {
      padding: theme.spacing(1, 2),
      height: 40,
    },
    headerContent: {
      overflow: 'hidden',
    },
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  };
};
